import { render, staticRenderFns } from "./MessageBanner.vue?vue&type=template&id=a7114b4c"
import script from "./MessageBanner.vue?vue&type=script&lang=ts"
export * from "./MessageBanner.vue?vue&type=script&lang=ts"
import style0 from "./MessageBanner.vue?vue&type=style&index=0&id=a7114b4c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports